import * as React from "react";
import type { SVGProps } from "react";
const SvgMove = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.586 6 6.293 4.707l1.414-1.414 3 3a1 1 0 0 1 0 1.414l-3 3-1.414-1.414L7.586 8H3a1 1 0 0 1 0-2zm6.728 0h2.338l.296.31 4.775 5 .277.29V15c0 1.308-.837 2.42-2.005 2.831q.005.083.005.17a3 3 0 0 1-6 0H9a3 3 0 1 1-5.989-.262A2 2 0 0 1 2 16v-4.555a1 1 0 1 1 2 0v4.319A3 3 0 0 1 6 15c.888 0 1.687.386 2.236 1h6.527c.55-.614 1.348-1 2.237-1 .877 0 1.667.377 2.215.977A1 1 0 0 0 20 15v-2.6L15.797 8h-1.483a1 1 0 1 1 0-2M6 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgMove;
